import {
  Box,
  VStack,
  Button,
  Text,
  Flex,
  Checkbox,
  Link,
  useToast,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import TextDisplay from "@/components/TextDisplay";
import { useProposalStore } from "@/contexts/useProposalStore";
import { BrlCurrencyFormatter } from "@/utils/BrlCurrencyFormatter";

// @ts-ignore
import { IDPaySDK } from "idpay-b2b-sdk";
import { useConditionalBackground } from "@/contexts/useConditionalBackground ";
import { useState } from "react";

export default function Confirmation() {
  const { proposal } = useProposalStore();
  const [isContractAccepted, setIsContractAccepted] = useState(false);
  const backgroundStyle = useConditionalBackground();
  const toast = useToast();
  const navigate = useNavigate();

  if (!proposal) {
    navigate("/404");
    return null;
  }

  const { chosenFinancialInfo } = proposal;
  const productName = chosenFinancialInfo?.Product?.name || "Não informado";
  const releasedAmount =
    chosenFinancialInfo?.releasedAmount != null
      ? BrlCurrencyFormatter(chosenFinancialInfo.releasedAmount)
      : "Não informado";
  const issueAmount =
    chosenFinancialInfo?.issueAmount != null
      ? BrlCurrencyFormatter(chosenFinancialInfo?.Installments?.slice(
        0,
        proposal.anticipatedYears ?? undefined
      ).reduce(
        (acc: any, installment: { payment: any; }) => acc + installment.payment,
        0
      ))
      : "Não informado";
  const monthlyRate =
    chosenFinancialInfo?.monthlyRate != null
      ? `${(chosenFinancialInfo.monthlyRate * 100).toFixed(2)}%`
      : "Não informado";
  const monthlyCET =
    chosenFinancialInfo?.monthlyCET != null
      ? `${(chosenFinancialInfo?.monthlyCET * 100).toFixed(2)}%`
      : "Não informado";
  const anticipatedYears =
    proposal.anticipatedYears != null
      ? `${proposal.anticipatedYears} anos`
      : "Não informado";

  const handleAcceptContract = () => {
    setIsContractAccepted(prev => !prev);
  };

  const handleAssinar = async () => {
    if (!isContractAccepted) {
      toast({
        title: "Assinatura pendente",
        description: "É necessário aceitar o contrato antes de prosseguir.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    window.location.href =
      import.meta.env.VITE_ENV === "local"
        ? `https://cadastro.uat.unico.app/process/${proposal.UnicoData!.unicoId}`
        : `https://cadastro.unico.app/process/${proposal.UnicoData!.unicoId}`;
  };

  return (
    <Box
      minHeight="100vh"
      {...backgroundStyle}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      px={4}
      py={6}
    >
      <VStack
        spacing={6}
        bg="white"
        p={6}
        borderRadius="lg"
        boxShadow="lg"
        width="100%"
        maxWidth="400px"
        align="start"
        color="gray.800"
        fontFamily="Lexend Deca"
      >
        <Text
          fontSize="xl"
          fontWeight="bold"
          color="primary"
          textAlign="center"
          width="100%"
        >
          Confirmação de Dados
        </Text>

        <Box width="100%">
          <Text fontSize="lg" fontWeight="medium" color="gray.600" mb={2}>
            Informações Financeiras
          </Text>
          <Box bg="gray.50" padding="4" borderRadius="md" boxShadow="sm">
            <VStack align="start" spacing="3">
              <TextDisplay label="Produto" value={productName} />
              <TextDisplay label="Valor Liberado" value={releasedAmount} />
              <TextDisplay label="Saldo Bloqueado" value={issueAmount} />
              <TextDisplay label="Taxa AM" value={monthlyRate} />
              <TextDisplay label="CET AM" value={monthlyCET} />
              <TextDisplay
                label="Anos de Antecipação"
                value={anticipatedYears}
              />
            </VStack>
          </Box>
        </Box>

        <Box>
          <Flex gap={1}>
            <Checkbox
              isChecked={isContractAccepted}
              onChange={handleAcceptContract}
              colorScheme="whiteLabeColor"
            >
            Li e estou de acordo com o
            </Checkbox>

            <Link
              href={proposal?.Contract?.contractUrl!}
              target="_blank"
              textDecoration="underline"
              textDecorationColor="whiteLabeColor.500"
              color="whiteLabeColor.500"
              fontWeight="semibold"
            >
              contrato
            </Link>

          </Flex>
        </Box>

        <Button
          isDisabled={!isContractAccepted}
          onClick={handleAssinar}
          colorScheme="primary"
          width="100%"
          borderRadius="full"
          py="6"
          mt="4"
          fontWeight="bold"
        >
          Assinar
        </Button>
      </VStack>
    </Box>
  );
}
